import React, { Component } from "react";
import PropTypes from "prop-types";

export default class Footer extends Component {
  render() {
    return <footer>{this.props.children}</footer>;
  }
}

Footer.propTypes = {
  children: PropTypes.any.isRequired,
};
